import React from 'react';
import { createBrowserRouter, createRoutesFromElements, Route, Navigate } from 'react-router-dom';
import AdminPanel from '../../AdminPanel';
import Tutoring from '../../AdminPanel/Tutoring';
import Checklists from '../../Checklists';
import Details from '../../Checklists/Details';
import Dashboard from '../../Dashboard';
import DevSpace from '../../DevSpace';
import Crud from '../../DevSpace/Crud';
import { MyInfo } from '../../MyInfo';
import Settings from '../../Settings';
import StatusAlerts from '../../StatusAlerts';
import Error from './Error';
import AdminRoute from './AdminRoute';
import { Locations } from '../../AdminPanel/Locations';
import AllApps from '../../AllApps';
import PowerRoute from './PowerRoute';
import AuthRedirect from '../../AuthRedirect';
import Landing from '../../Landing';
import CCTWrapper from '../../MyCourses/CCT/CCTWrapper';
import Feedback from '../../AdminPanel/Feedback';
import CognitoErrorLog from '../../AdminPanel/CognitoErrorLog';
import { FrontEndErrorLog } from '../../AdminPanel/FrontEndErrorLog';
import SAM from '../../SAM';
import ATS from '../../ATS';
import AssignedStudents from '../../SAM/AssignedStudents';
import UnassignedStudents from '../../SAM/UnassignedStudents';
import DifferentMajor from '../../SAM/DifferentMajor';
import MissingAdvisorCode from '../../SAM/MissingAdvisorCode';
import ValidatedRoute from './ValidatedRoute';
import {
  isUserATS,
  isUserSAM,
  isUserSAMPowerUp,
  isUserSAMPowerUser,
  isUserSAMSuperUser,
} from '../utils';
import { DatatablePage } from '../../SSA/DatatablePage';
import AutoAssignmentReport from '../../SAM/AutoAssignmentReport';
import { ReportPage } from '../../SSA/ReportPage';
import { AdvisorSummary } from '../../SAM/AdvisorSummary';
import { SSA } from '../../SSA';
import ActionHistory from '../../ATS/ActionHistory';
import Courses from '../../ATS/Courses';
import Codecs from '../../ATS/Codecs';
import CourseDetails from '../../ATS/CourseDetails';
import AutoUnassignmentReport from '../../SAM/DiffMajorAutoUnassignmentReport';
import { RulesUpdateReport } from '../../SAM/AdvisorRules/RulesUpdateReport';
import StudentSearch from '../../SAM/studentSearch';
import { InactiveAutoAssignmentReport } from '../../SAM/InactiveAutoAssignmentReport';
import { MonarchMind } from '../../MonarchMind';
import { ESGA } from '../../MonarchMind/ESGA';

const router = (isLoggedIn) => {
  return createBrowserRouter(
    createRoutesFromElements(
      <Route path="/" errorElement={<Error isLoggedIn={isLoggedIn} />}>
        <Route
          index
          element={
            isLoggedIn ? (
              <AuthRedirect
                path={window.location.pathname}
                isLoggedIn={isLoggedIn}
                element={<Dashboard />}
              />
            ) : (
              <Landing />
            )
          }
        />
        <Route path="devSpace">
          <Route
            index
            element={
              <AuthRedirect
                path={window.location.pathname}
                isLoggedIn={isLoggedIn}
                element={<AdminRoute element={<DevSpace />} />}
              />
            }
          />
          <Route
            path="crud"
            element={
              <AuthRedirect
                path={window.location.pathname}
                isLoggedIn={isLoggedIn}
                element={<AdminRoute element={<Crud />} />}
              />
            }
          />
        </Route>
        <Route path="admin">
          <Route
            index
            element={
              <AuthRedirect
                path={window.location.pathname}
                isLoggedIn={isLoggedIn}
                element={<AdminRoute element={<AdminPanel />} />}
              />
            }
          />
          <Route
            path="tutoring"
            element={
              <AuthRedirect
                path={window.location.pathname}
                isLoggedIn={isLoggedIn}
                element={<PowerRoute element={<Tutoring />} />}
              />
            }
          />
          <Route
            path="locations"
            element={
              <AuthRedirect
                path={window.location.pathname}
                isLoggedIn={isLoggedIn}
                element={<PowerRoute element={<Locations />} />}
              />
            }
          />
          <Route
            path="feedback"
            element={
              <AuthRedirect
                path={window.location.pathname}
                isLoggedIn={isLoggedIn}
                element={<AdminRoute element={<Feedback />} />}
              />
            }
          />
          <Route
            path="cognito-error-log"
            element={
              <AuthRedirect
                path={window.location.pathname}
                isLoggedIn={isLoggedIn}
                element={<AdminRoute element={<CognitoErrorLog />} />}
              />
            }
          />
          <Route
            path="frontend-error-log"
            element={
              <AuthRedirect
                path={window.location.pathname}
                isLoggedIn={isLoggedIn}
                element={<AdminRoute element={<FrontEndErrorLog />} />}
              />
            }
          />
        </Route>
        <Route path="sam">
          <Route
            index
            element={
              <AuthRedirect
                path={window.location.pathname}
                isLoggedIn={isLoggedIn}
                element={<ValidatedRoute validator={isUserSAM} element={<SAM />} />}
              />
            }
          />
          <Route
            path="student-assigned"
            element={
              <AuthRedirect
                path={window.location.pathname}
                isLoggedIn={isLoggedIn}
                element={<ValidatedRoute validator={isUserSAM} element={<AssignedStudents />} />}
              />
            }
          />
          <Route
            path="student-unassigned"
            element={
              <AuthRedirect
                path={window.location.pathname}
                isLoggedIn={isLoggedIn}
                element={<ValidatedRoute validator={isUserSAM} element={<UnassignedStudents />} />}
              />
            }
          />
          <Route
            path="student-change-major"
            element={
              <AuthRedirect
                path={window.location.pathname}
                isLoggedIn={isLoggedIn}
                element={<ValidatedRoute validator={isUserSAM} element={<DifferentMajor />} />}
              />
            }
          />
          <Route
            path="student-missing-advisor-code"
            element={
              <AuthRedirect
                path={window.location.pathname}
                isLoggedIn={isLoggedIn}
                element={
                  <ValidatedRoute validator={isUserSAMPowerUp} element={<MissingAdvisorCode />} />
                }
              />
            }
          />

          <Route
            path="advisor-summary"
            element={
              <AuthRedirect
                path={window.location.pathname}
                isLoggedIn={isLoggedIn}
                element={
                  <ValidatedRoute validator={isUserSAMPowerUp} element={<AdvisorSummary />} />
                }
              />
            }
          />

          <Route
            path="student-search"
            element={
              <AuthRedirect
                path={window.location.pathname}
                isLoggedIn={isLoggedIn}
                element={<ValidatedRoute validator={isUserSAM} element={<StudentSearch />} />}
              />
            }
          />

          <Route
            path="auto-assignment-report"
            element={
              <AuthRedirect
                path={window.location.pathname}
                isLoggedIn={isLoggedIn}
                element={
                  <ValidatedRoute
                    validator={isUserSAMSuperUser}
                    element={<AutoAssignmentReport />}
                  />
                }
              />
            }
          />

          <Route
            path="diff-major-auto-unassignment-report"
            element={
              <AuthRedirect
                path={window.location.pathname}
                isLoggedIn={isLoggedIn}
                element={
                  <ValidatedRoute
                    validator={isUserSAMSuperUser}
                    element={<AutoUnassignmentReport />}
                  />
                }
              />
            }
          />

          <Route
            path="rules-update-report"
            element={
              <AuthRedirect
                path={window.location.pathname}
                isLoggedIn={isLoggedIn}
                element={
                  <ValidatedRoute validator={isUserSAMSuperUser} element={<RulesUpdateReport />} />
                }
              />
            }
          />

          <Route
            path="inactive-auto-unassignment-report"
            element={
              <AuthRedirect
                path={window.location.pathname}
                isLoggedIn={isLoggedIn}
                element={
                  <ValidatedRoute
                    validator={isUserSAMSuperUser}
                    element={<InactiveAutoAssignmentReport />}
                  />
                }
              />
            }
          />
        </Route>
        <Route path="monarchMind">
          <Route
            index
            element={
              <AuthRedirect
                path={window.location.pathname}
                isLoggedIn={isLoggedIn}
                element={<MonarchMind />}
              />
            }
          />
          <Route
            path="esga"
            element={
              <AuthRedirect
                path={window.location.pathname}
                isLoggedIn={isLoggedIn}
                element={<ESGA />}
              />
            }
          />
          <Route
            path="esga/:sessionId"
            element={
              <AuthRedirect
                path={window.location.pathname}
                isLoggedIn={isLoggedIn}
                element={<ESGA />}
              />
            }
          />
        </Route>
        <Route path="ats">
          <Route
            index
            element={
              <AuthRedirect
                path={window.location.pathname}
                isLoggedIn={isLoggedIn}
                element={<ValidatedRoute validator={isUserATS} element={<ATS />} />}
              />
            }
          />
          <Route
            path="courses"
            element={
              <AuthRedirect
                path={window.location.pathname}
                isLoggedIn={isLoggedIn}
                element={<ValidatedRoute validator={isUserATS} element={<Courses />} />}
              />
            }
          />
          <Route
            path="courses/:termCode/:minCrn"
            element={
              <AuthRedirect
                path={window.location.pathname}
                isLoggedIn={isLoggedIn}
                element={<ValidatedRoute validator={isUserATS} element={<CourseDetails />} />}
              />
            }
          />
          <Route
            path="codecs"
            element={
              <AuthRedirect
                path={window.location.pathname}
                isLoggedIn={isLoggedIn}
                element={<ValidatedRoute validator={isUserATS} element={<Codecs />} />}
              />
            }
          />
          <Route
            path="actionHistory"
            element={
              <AuthRedirect
                path={window.location.pathname}
                isLoggedIn={isLoggedIn}
                element={<ValidatedRoute validator={isUserATS} element={<ActionHistory />} />}
              />
            }
          />
        </Route>
        <Route
          path="statusAlerts"
          element={
            <AuthRedirect
              path={window.location.pathname}
              isLoggedIn={isLoggedIn}
              element={<StatusAlerts />}
            />
          }
        />
        <Route
          path="settings"
          element={
            <AuthRedirect
              path={window.location.pathname}
              isLoggedIn={isLoggedIn}
              element={<Settings />}
            />
          }
        />
        <Route
          path="checklists"
          element={
            <AuthRedirect
              path={window.location.pathname}
              isLoggedIn={isLoggedIn}
              element={<Checklists />}
            />
          }
        />
        <Route
          path="checklists/:code"
          element={
            <AuthRedirect
              path={window.location.pathname}
              isLoggedIn={isLoggedIn}
              element={<Details />}
            />
          }
        />
        <Route
          // Redirect from old portal checklist details url to the new portal checklist details url to support the ODUMobile app version 5.11
          path="ckdetail/:code"
          element={
            <Navigate to={'/checklists/' + window.location.pathname.split('/')[2]} replace />
          }
        />
        <Route
          path="myInfo"
          element={
            <AuthRedirect
              path={window.location.pathname}
              isLoggedIn={isLoggedIn}
              element={<MyInfo />}
            />
          }
        />
        <Route path="studentProgress">
          <Route
            element={
              <AuthRedirect
                path={window.location.pathname}
                isLoggedIn={isLoggedIn}
                element={<SSA />}
              />
            }
          >
            <Route path=":termCode/:crn" element={<DatatablePage />} />
            <Route path="report/:termCode/:crn" element={<ReportPage />} />
          </Route>
        </Route>
        <Route
          path="allApps"
          element={
            <AuthRedirect
              path={window.location.pathname}
              isLoggedIn={isLoggedIn}
              element={<AllApps />}
            />
          }
        />
        <Route
          path="lti/:session"
          element={<CCTWrapper />}
          errorElement={<Error isHideLayout isHideHomePage />}
        />
        <Route
          path="login"
          // If the user is not logged-in, redirect the user to Shibboleth page. If the user is already logged-in, the route https://.../login should not trigger another authentication. Let's just move the page to / instead.
          element={isLoggedIn ? <Navigate to="/" replace /> : <AuthRedirect />}
        />
      </Route>,
    ),
  );
};

export default router;
